export default __webpack_public_path__ + "static/new7-10-ae1d4390fc0a61d44a87c1069a43598c.jpg";